<template>
  <div class="invests">
    <h2 class="invest-title">
      <div class="titleName">新东方投资</div>
      <div class="PageTurning" v-show="PageTurning">
        <i @click="prePagae"><img src="http://images.xdf.cn/cms20150819/zuixinban/images/arrow_leftoff.png" alt=""></i>
        <i @click="nextPage"><img src="http://images.xdf.cn/cms20150819/zuixinban/images/arrow_rightoff.png" alt=""></i>
      </div>
    </h2>
    <div
      class="invest-content"
      v-for="(everyPageList, pageNum) in investLists"
      :key="pageNum"
      v-show="currPage === pageNum"
    >
      <div
        class="contentItem"
        v-for="(item, index) in everyPageList"
        :key="index"
      >
        <div :class="['item', !item ? 'hide' : '']">
          <a class="imgBox" :title="item.organization" :href="item.url">
            <img class="itemImg" :src="item.imgUrl" :alt="item.organization" :style="item.style">
          </a>
          <div class="phone">{{item.phone}}</div>
          <div class="reserve">
            <a class="bdright" :href="item.advisory">在线咨询</a>
            <a :href="item.url">预约</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { invest } from 'js/home/invest.js'
export default {
  name: 'XdfInvest',
  data () {
    return {
      currPage: 0,
      investLists: []
    }
  },
  computed: {
    PageTurning () {
      if (invest.length > 5) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getInvestLists()
  },
  methods: {
    nextPage () {
      this.currPage++
      if (this.currPage > this.investLists.length - 1) {
        this.currPage = 0
      }
    },
    prePagae () {
      this.currPage--
      if (this.currPage < 0) {
        this.currPage = this.investLists.length - 1
      }
    },
    getInvestLists () {
      let len = Math.ceil(invest.length / 5)
      for (let i = 0; i < len; i++) {
        for (let j = i * 5; j < (i + 1) * 5; j++) {
          if (!this.investLists[i]) {
            this.investLists[i] = []
          }
          if (!invest[j]) {
            invest[j] = ''
          }
          this.investLists[i].push(invest[j])
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.invests
  width: 1200px
  height: 190px
  margin: 18px auto 0
  display: flex
  flex-direction: column
  .invest-title
    flex: 1
    border-bottom: 1px solid #e2e2e2
    width :100%
    height :40px\9\0
    .titleName
      float: left
      font-size: 18px
      line-height: 38px
      color: #333
    .PageTurning
      height: 50%
      line-height: 38px
      float: right
      i
        margin: 0 5px
        cursor: pointer
  .invest-content
    flex: 5
    height: 100%
    display: flex
    color: #979797
    height :50px\9\0
    .contentItem
      flex: 1
      .item
        width: 218px
        margin: 0 auto
        position: relative
        top: 50%
        border: 1px solid #eee
        background-color: #fff
        text-align: center
        margin-top: -60px
        display: flex
        padding: 0 5px
        flex-direction: column
        margin-top:20px
      .hide
        visibility: hidden
      .imgBox
        display: flex
        flex: 6
        flex-direction: column
        img
          margin: 0 auto
      .phone
        flex: 1
        font-size: 14px
        line-height: 21px
      .reserve
        display: flex
        padding: 5px 0
        flex: 2
        border-top: 1px solid #eae9e9
        a
          flex: 1
          line-height: 22px
          color: #8c8c8c
          cursor: pointer
          &:hover
            color: #38bca4
        .bdright
          border-right: 1px solid #eae9e9
</style>



// WEBPACK FOOTER //
// src/pages/home/components/XdfInvest.vue